import { createContext, useContext } from "react";

export const HeroContext = createContext({
	hoveredPane: null,
	setHoveredPane: () => {},
	heroColor: "#bdbdbd",
	setHeroColor: () => {},
});

export const useHeroContext = () => useContext(HeroContext);
